import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { formatMessageDate, formatAMPM } from '../../../../../../helpers/utils';
import { useStores } from 'stores';
import styles from '../../../ChatWindow.module.scss';

const AnotherUserMessage = ({ message, showDate }) => {
  const {
    messageStore: { lastReadMessage, updateLastReadMessage },
  } = useStores();

  const today = new Date();
  const messageDate = message.added;

  const observedRef = useRef(null);

  useEffect(() => {
    // For messages whose id is higher than lastReadMessage
    // attach interestionObserver, on hit send the update
    // to backend with the new/current id and remove the observer
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          updateLastReadMessage(message.id);
          observer.disconnect();
        }
      });
    });

    if (message.id > lastReadMessage) {
      observer.observe(observedRef.current);
    }

    // remove interestionObserver on unmount
    return () => observer.disconnect();
  }, []);

  const renderDate = useCallback(
    () => (
      <p className={styles['message-date']}>
        {today.toDateString() === messageDate.toDateString() ? 'Today' : formatMessageDate(message.added)}
      </p>
    ),
    [message, messageDate, today]
  );

  return (
    <div ref={observedRef} className={cn(styles['message-wrapper'], styles['left-margin'])}>
      <div>
        {showDate && renderDate()}

        <div className={cn(styles.message, styles['message-from-other-user'])}>
          <p className={styles['message-text']}>{message.text}</p>
          <span className={styles['message-time']}>{formatAMPM(message.added)}</span>
        </div>
      </div>
    </div>
  );
};

AnotherUserMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number,
    conversationId: PropTypes.number,
    userId: PropTypes.string,
    userFirstName: PropTypes.string,
    userLastName: PropTypes.string,
    added: PropTypes.instanceOf(Date).isRequired,
    text: PropTypes.string,
  }).isRequired,
  showDate: PropTypes.bool.isRequired,
};

export default AnotherUserMessage;
